import {
  PlayerName,
  PlayerProfile,
  PlayerSubheader
} from '@library/components/player';
import { DateTime } from 'luxon';
import type { FormattedMission } from '@library/types/missions';
import { PayoutTypeSelect } from '@library/components/selects/PayoutTypeSelect';
import type { PromotionPayoutType } from '@library/types/promotions';
import { convertToDollars } from '@library/utils';
import { formatMission } from '@bo-utils/missions';
import { formatWithTimezoneChange } from '@library/utils/dateTime';

export interface MissionContentProps {
  mission: FormattedMission;
}

export const MissionRow = ({ mission }: MissionContentProps) => {
  const {
    name,
    description,
    optInBy,
    completeBy,
    payoutAmountUsd,
    payoutType
  } = formatMission(mission);

  const formattedCompleteBy = formatWithTimezoneChange(
    DateTime.fromISO(completeBy),
    'MMM d, yyyy'
  );
  const formattedOptInBy = formatWithTimezoneChange(
    DateTime.fromISO(optInBy),
    'MMM d, yyyy'
  );
  const formattedPayoutAmount = convertToDollars(Number(payoutAmountUsd));

  return (
    <div className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 group/user text-2xs relative flex items-center border-b xl:text-xs">
      <PlayerProfile
        className="flex w-1/3 items-center p-3"
        name={name}
        subheader={description}
      >
        <div className="flex flex-col">
          <PlayerName className="font-heebo text-soClean-100 block text-sm font-medium capitalize tracking-tight" />
          <PlayerSubheader className="text-soClean-170 font-heebo block text-xs font-medium tracking-tight" />
        </div>
      </PlayerProfile>

      <p className="w-1/5 p-3">{formattedOptInBy}</p>
      <p className="w-1/5 p-3">{formattedCompleteBy}</p>
      <div className="w-1/5 p-3">{formattedPayoutAmount}</div>
      <div className="w-1/5 p-3">
        <PayoutTypeSelect
          containerClassName="!h-6"
          className="!h-6 !min-h-0 bg-transparent !py-0 !pl-3 !pr-6"
          onChange={() => {}}
          value={payoutType as PromotionPayoutType}
        />
      </div>
    </div>
  );
};
